import { Component, EventEmitter, inject, OnInit, Output, signal } from '@angular/core';
import { FormControl, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { IntegrationsApiService } from '@shared/services/integrations-api.service';
import { CommonModalFormComponent } from '@shared/components/commons/common-modal-form/common-modal-form.component';
import { ConnectionStatusEnum } from '@models/integrations/connection-status.enum';
import { AnnatureAccountModel } from '../../../../../../models/annature/annature-account-model';
import { SelectComponent } from '@shared/controls/select/select.component';
import { SelectOption } from '@models/ui-models/select-options';

@Component({
  selector: 'app-annature-pick-account-modal',
  standalone: true,
  imports: [
    ReactiveFormsModule,
    SelectComponent,
    CommonModalFormComponent,
    FormsModule,
  ],
  templateUrl: 'annature-pick-account-modal.component.html',
})
export class AnnaturePickAccountModalComponent implements OnInit {
  private activeModal = inject(NgbActiveModal);
  private integrationsService = inject(IntegrationsApiService);
  private toastr = inject(ToastrService);

  @Output() confirmEvent = new EventEmitter<ConnectionStatusEnum>();

  isLoading = signal(false);
  accountOptions: SelectOption[] = [];
  accountList: AnnatureAccountModel[] = [];
  pickedAccountIdControl = new FormControl<string | null>(null, [Validators.required]);

  ngOnInit(): void {
    this.integrationsService.getAnnatureAccountList()
      .subscribe((accounts) => {
        this.accountOptions = accounts.map(account => ({
          label: `${ account.name } (${ account.email })`,
          value: account.id,
        }));

        this.accountList = accounts;
      });
  }

  confirm(): void {
    if (!this.pickedAccountIdControl.valid) {
      this.toastr.warning('Please select an account');
      return;
    }

    const pickedAccountId = this.pickedAccountIdControl.value;
    const account = this.accountList.find(acc => acc.id === pickedAccountId);

    if (!account) {
      this.toastr.error('Account not found');
      return;
    }

    this.isLoading.set(true);
    this.pickedAccountIdControl.disable();

    this.integrationsService.setAnnatureAccount(account)
      .subscribe({
        next: (status) => {
          this.toastr.success('Connected!', 'Success');
          this.confirmEvent.emit(status);
          this.activeModal.close();
        },
        error: () => {
          this.isLoading.set(false);
          this.toastr.error('Connection Failed!', 'Error');
          this.pickedAccountIdControl.enable();
        }
      });
  }

  close(): void {
    this.confirmEvent.emit(ConnectionStatusEnum.NotConnected);
    this.activeModal.dismiss();
  }
}
